// Libraries
import styled, { css } from 'styled-components'
import { motion } from 'framer-motion'

export const StyledCheckBox = styled.input.attrs({ type: 'checkbox' })`
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

interface PropsInterface {
  isChecked?: boolean;
  label?: string;
  $isError?: boolean;
}

export const StyledSpan = styled.span`
  position: relative;
  display: inline-block;
  height: 30px;
  margin-right: 15px;
  width: ${({ label }: PropsInterface) => label ? '40px' : '42px'};
  ${({ theme }) => css`
    ${theme.media.tablet} {
      width: ${({ label }: PropsInterface) => label ? '50px' : '40px'};
    }
    ${theme.media.mobileL} {
      width: ${({ label }: PropsInterface) => label ? '50px' : '50px'};
    }
    ${theme.media.mobileM} {
      width: ${({ label }: PropsInterface) => label ? '55px' : '58px'};
    }
  `}
  background-color: rgba(255, 255, 255, 0.2);
  ${({ isChecked }: PropsInterface) => isChecked && "background-image: url('/asterisk.svg')"};
  background-position: center center;
  background-repeat: no-repeat;
  border: 1px solid #fff;
  :hover {
    cursor: pointer;
  }
`;

export const StyledLabel = styled.label`
  display: flex;
  color: #fff;
  margin: 10px 15px 20px 0;
  align-items: center;
  text-align: left;
  font-family: "Avenir Next Regular", sans-serif;
  font-size: 14px;
  line-height: 19px;
  ${({ $isError: isError }: PropsInterface) => isError && 'color: #e20004'}
  ${({ label }: PropsInterface) => label && 'column-gap: 15px'}
`;

export const Check = styled(motion.img)`
  position: absolute;
  top: 25%;
  left: 25%;
  transform: translateX(-50%) translateY(-50%);
  user-select: none;
  :hover {
    cursor: pointer;
  }
`;